export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "total_hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hectáreas"])},
          "total_square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["m²"])},
          "download_producers_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar productores"])},
          "download_crop_fields_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar productores y campos"])}
        }
      }
    }
  })
}